import { useFragment } from "@apollo/client";
import type { BasketMembershipToggleCardType } from "@shared/graphql.types";
import { MEMBERSHIP_TOGGLE_CARD_FRAGMENT } from "@shared/graphql.fragments";

export const useGetMembershipToggleCardData =
  (): BasketMembershipToggleCardType => {
    const { data } = useFragment<BasketMembershipToggleCardType>({
      fragment: MEMBERSHIP_TOGGLE_CARD_FRAGMENT,
      fragmentName: "MembershipToggleCardFragment",
      from: {
        __typename: "BasketMembershipToggleCardType",
        id: "basket-membership-toggle"
      }
    });

    return data as BasketMembershipToggleCardType;
  };
